import { render, staticRenderFns } from "./RiskyEventsModal.vue?vue&type=template&id=8cea48a2&"
import script from "./RiskyEventsModal.vue?vue&type=script&lang=ts&"
export * from "./RiskyEventsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports